import { H1, H3 } from "@sorcery/ui";

export const SlimTitle = ({
  title,
  subtitle,
  orientation = "center",
}: {
  title: string;
  subtitle?: string;
  orientation?: "left" | "center";
}) => {
  return (
    <section
      className={`sorcery-section container mx-auto ${
        orientation === "center" ? "text-center" : "text-left"
      }`}
    >
      <div className="sm:!mb-14 sm:!mt-12">
        <H1 className="!mb-0 text-big-text-color sm:!text-6xl">{title}</H1>
        {subtitle && <H3 className="!text-xl">{subtitle}</H3>}
      </div>
    </section>
  );
};
